export default "__VITE_ASSET__0LTaH5Ct__"